import React from "react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-bark-bg">
      <SiteHeader />
      <main className="flex-1 relative z-10">{children}</main>
      <SiteFooter />
    </div>
  );
}
